import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AtualizacaoInformacoesRiscoOperacao } from 'src/app/model/atualizacao-info-risco.model';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { STATUS_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';

@Component({
    selector: 'app-atualizacao-info-risco-listagem',
    templateUrl: './atualizacao-info-risco-listagem.component.html',
    styleUrls: ['./atualizacao-info-risco-listagem.component.scss'],
    standalone: false
})
export class AtualizacaoInfoRiscoListagemComponent {

  @Input() public atualizacoesInfoRisco: AtualizacaoInformacoesRiscoOperacao[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public ehAgenteFinanceiro: boolean;
  
  @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Input() agentesFinanceiros: AgenteFinanceiro[];

  public atributosOrdenacao: EntityOrderedRequestParameters;
  public opcoesPaginacao: number[] = [10, 15, 20]

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }
  
  nomeAgenteFinanceiro(cnpj: string) {
    return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.atualizacoesInfoRisco = this.atualizacoesInfoRisco.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  obterLabelStatusProtocolo(statusProtocolo: string) {
    if (statusProtocolo == undefined) {
      return undefined;
    }
    return STATUS_PROTOCOLO.find(status => status.codigo === statusProtocolo).label;
  }

}